import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import urlJoin from 'url-join';

import { toFilteringUrl } from '../utility';
import { ApiResponse } from '../models/api-response';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getUsers(filter: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      toFilteringUrl(urlJoin(this.appConfig.apiUrl, '/User/GetUsers'), filter),
    );
  }

  getUserDetails(userId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      urlJoin(this.appConfig.apiUrl, '/User/GetUSERDetails', `?userId=${userId}`),
    );
  }

  getUserPermissions(id: number, portalId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      urlJoin(this.appConfig.apiUrl, `User/GetUserPermissions?userId=${id}&portalId=${portalId}`),
    );
  }

  addUser(role: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(urlJoin(this.appConfig.apiUrl, '/User/AddUser'), role);
  }

  updateUser(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(urlJoin(this.appConfig.apiUrl, '/User/EditUser'), data);
  }

  logoutUser(userId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      urlJoin(this.appConfig.apiUrl, '/User/Logout', `?userId=${userId}`),
      {},
    );
  }
}
